var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInstitutionIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 18,
    viewBox: "0 0 20 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.9996 3.85715V4.50001C19.9996 4.58526 19.9657 4.66701 19.9054 4.72729C19.8451 4.78757 19.7634 4.82144 19.6781 4.82144H18.7139V5.30358C18.7139 5.56984 18.498 5.78572 18.2317 5.78572H2.48172C2.21546 5.78572 1.99958 5.56984 1.99958 5.30358V4.82144H1.0353C0.950047 4.82144 0.868291 4.78757 0.808011 4.72729C0.747732 4.66701 0.713867 4.58526 0.713867 4.50001V3.85715C0.713868 3.79356 0.73273 3.7314 0.768068 3.67853C0.803406 3.62566 0.853631 3.58447 0.912389 3.56015L10.2338 0.0244395C10.3125 -0.00814649 10.4009 -0.00814649 10.4796 0.0244395L19.801 3.56015C19.8598 3.58447 19.91 3.62566 19.9454 3.67853C19.9807 3.7314 19.9996 3.79356 19.9996 3.85715ZM19.0353 16.0714H1.67815C1.14559 16.0714 0.713867 16.5031 0.713867 17.0357V17.6786C0.713867 17.7638 0.747732 17.8456 0.808011 17.9059C0.868291 17.9661 0.950047 18 1.0353 18H19.6781C19.7634 18 19.8451 17.9661 19.9054 17.9059C19.9657 17.8456 19.9996 17.7638 19.9996 17.6786V17.0357C19.9996 16.5031 19.5679 16.0714 19.0353 16.0714ZM3.92815 6.42858V14.1429H2.48172C2.21546 14.1429 1.99958 14.3587 1.99958 14.625V15.4286H18.7139V14.625C18.7139 14.3587 18.498 14.1429 18.2317 14.1429H16.7853V6.42858H14.2139V14.1429H11.6424V6.42858H9.071V14.1429H6.49958V6.42858H3.92815Z",
    fill: "#151515",
    className: "hc-mode-institute"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstitutionIcon);
export default __webpack_public_path__ + "static/media/institution-icon.c4c945793fa92206f1741327d312726a.svg";
export { ForwardRef as ReactComponent };